import { Link } from '@tanstack/react-router';
import { CircleArrowLeft, FileText, History, Settings } from 'lucide-react';

import { Button } from '~shared/shadcn/ui/button';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

export const HourlyTuitions = () => {
  return (
    <div className=''>
      <div className='mb-4 border-b pb-4'>
        <Link className='flex w-fit items-center gap-2' to='/dashboard'>
          <CircleArrowLeft className='size-6 text-custom-secondary-1' />
          <h2 className='min-w-0 text-xl font-semibold text-custom-secondary-1 sm:text-2xl'>
            Hourly Tuition
          </h2>
        </Link>
      </div>
      <div className='mx-auto max-w-4xl space-y-8 pt-8'>
        {/* <div className='text-center'>
          <h1 className='mb-4 text-4xl font-bold text-[#1F1F1F]'>
            Hourly Tuition
          </h1>
        </div> */}

        <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3'>
          <Card className='rounded-xl bg-[#F9FAFB] shadow-sm transition-shadow hover:shadow-md'>
            <CardHeader className='p-6 text-center'>
              <Settings className='mx-auto mb-4 size-12 text-[#FDC500]' />
              <CardTitle className='text-xl font-semibold text-[#1F1F1F]'>
                Settings
              </CardTitle>
            </CardHeader>
            <CardContent className='p-6 pt-0 text-center'>
              <p className='mb-4 text-[#6B7280]'>
                Configure hourly tuition rates and system preferences
              </p>
              <Link to='/payment/hourly-tuition/settings'>
                <Button className='w-full rounded-lg bg-[#002D62] px-4 py-2 font-semibold text-white hover:bg-[#001F4D]'>
                  Manage Settings
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className='rounded-xl bg-[#F9FAFB] shadow-sm transition-shadow hover:shadow-md'>
            <CardHeader className='p-6 text-center'>
              <FileText className='mx-auto mb-4 size-12 text-[#FDC500]' />
              <CardTitle className='text-xl font-semibold text-[#1F1F1F]'>
                Post Tuition
              </CardTitle>
            </CardHeader>
            <CardContent className='p-6 pt-0 text-center'>
              <p className='mb-4 text-[#6B7280]'>
                Settle tuition for the selected period and post it to the
                student&apos;s account.
              </p>
              <Link to='/payment/hourly-tuition/review'>
                <Button className='w-full rounded-lg bg-[#FDC500] px-4 py-2 font-semibold text-black hover:bg-[#E6B200]'>
                  Create Report
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className='rounded-xl bg-[#F9FAFB] shadow-sm transition-shadow hover:shadow-md'>
            <CardHeader className='p-6 text-center'>
              <History className='mx-auto mb-4 size-12 text-[#FDC500]' />
              <CardTitle className='text-xl font-semibold text-[#1F1F1F]'>
                Drafts History
              </CardTitle>
            </CardHeader>
            <CardContent className='p-6 pt-0 text-center'>
              <p className='mb-4 text-[#6B7280]'>
                View and manage saved hourly tuition billing drafts
              </p>
              <Link to='/payment/hourly-tuition/drafts'>
                <Button className='w-full rounded-lg bg-[#002D62] px-4 py-2 font-semibold text-white hover:bg-[#001F4D]'>
                  View Drafts
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
